import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import './offices-swiper-custom.css';

const images = [
  {
    src: require("assets/img/clinic-images/jpg/IMG_2562.jpg"),
    altText: "Fachada del consultorio"
  },
  {
    src: require("assets/img/clinic-images/jpg/IMG_2580.jpg"),
    altText: "Interior del consultorio"
  },
  {
    src: require("assets/img/clinic-images/jpg/IMG_2620.jpg"),
    altText: "Sala de espera"
  },
  {
    src: require("assets/img/clinic-images/jpg/IMG_0726.jpg"),
    altText: "Consultorio"
  },
  {
    src: require("assets/img/offices/WhatsApp Image 2025-05-26 at 11.56.58.jpeg"),
    altText: "Instalación 1"
  },
  {
    src: require("assets/img/offices/WhatsApp Image 2025-05-26 at 11.57.02.jpeg"),
    altText: "Instalación 2"
  },
  {
    src: require("assets/img/offices/WhatsApp Image 2025-05-26 at 11.57.33.jpeg"),
    altText: "Instalación 3"
  },
  {
    src: require("assets/img/offices/WhatsApp Image 2025-05-26 at 11.57.48.jpeg"),
    altText: "Instalación 4"
  },
  {
    src: require("assets/img/offices/WhatsApp Image 2025-05-26 at 11.57.49.jpeg"),
    altText: "Instalación 5"
  },
  {
    src: require("assets/img/offices/WhatsApp Image 2025-05-26 at 12.01.23.jpeg"),
    altText: "Instalación 6"
  },
  {
    src: require("assets/img/offices/WhatsApp Image 2025-05-26 at 12.01.23 (1).jpeg"),
    altText: "Instalación 7"
  },
  {
    src: require("assets/img/offices/WhatsApp Image 2025-05-26 at 12.01.23 (2).jpeg"),
    altText: "Instalación 8"
  }
];

export default function Offices() {
  return (
    <div className="section" id="offices">
      <Container>
        <Row className="justify-content-center mb-4">
          <Col md="8" className="text-center">
            <h2 className="section-title reveal">Nuestras instalaciones</h2>
            <p className="section-lead reveal">Conocé nuestro espacio y consultorios.</p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="12">
            <Swiper
              modules={[EffectCoverflow, Navigation, Pagination, Autoplay]}
              effect="coverflow"
              coverflowEffect={{
                rotate: 10,
                stretch: 0,
                depth: 80,
                modifier: 1.5,
                slideShadows: false
              }}
              centeredSlides
              slidesPerView={3}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              loop
              className="offices-swiper"
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1200: { slidesPerView: 3 }
              }}
            >
              {images.map((item, idx) => (
                <SwiperSlide key={idx} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <img
                    src={item.src}
                    alt={item.altText}
                    loading="lazy"
                    className="office-slide-img"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </div>
  );
} 